<ng-container *ngIf="IsCreatePostFormVisible">
    <app-overlay-container classList="d-flex align-items-center justify-content-center">
        <div class="form_container w-100">
            <app-content-card classList="padding_full_4 padding_bottom_10 border_radius_4 border_solid border_main_color">
                <form (ngSubmit)="Submit()" [formGroup]="Form">
                    <div class="form_card_header d-flex justify-content-between align-items-center gap-3 text-center margin_bottom_8">
                        <span (click)="CloseForm()" class="text-start pointer">
                            <app-close-icon />
                        </span>
                        <span class="font_14 font_700 color_black">المنشور</span>
                        <div class="wrap_btn_submit text-end">
                            <button type="submit" [disabled]="Form.invalid || isUploadingFiles" class="btn font_14 font_700 bg_main_color color_white padding_x_4 padding_y_2 border_radius_8">
                                <app-check-icon class="d-inline-block margin_end_3" />
                                <span>تم</span>
                            </button>
                        </div>
                    </div>
                    <div class="form_card_body">
                        <div class="wrap_div_text_area text-center margin_bottom_7 position-relative">
                            <div 
                                inputmode="true"
                                contenteditable="true"
                                (input)="InputChange($event)"
                                placeholder="أكتب هنا الخبر ...."
                                class="div_text_area font_14 font_500 custom_scroll bg_white border_solid border_main_color border_radius_5 padding_full_4 text-start overflow-y-auto"
                            >
                            </div>
                            <div id="div_input_placeholder" class="div_input_placeholder position-absolute font_14 font_500 color_p_color d-inline-block">أكتب هنا الخبر ....</div>
                        </div>
                    </div>
                    <div class="form_card_footer d-flex justify-content-center justify-content-sm-between align-items-center flex-wrap gap-3">
                        <label for="upload_file" class="upload_file d-inline-block position-relative pointer border_solid border_main_color border_radius_9 padding_y_2 padding_x_6">
                            <input 
                                type="file" 
                                id="upload_file"
                                multiple="true"
                                (change)="UploadFile($event)"
                                [disabled]="isUploadingFiles"
                                accept="image/*, video/*, application/pdf"
                                class="position-absolute top-0 start-0 w-100 h-100 d-none"
                            />
                            <app-add-media-icon class="d-inline-block margin_end_5" />
                            <span class="font_14 font_700 color_main_color">أضف صورة/فيديو</span>
                        </label>
                        <div class="wrap_progress d-flex justify-content-between align-items-center">
                            <span class="font_14 font_700 color_main_color margin_end_5">أكتب نسبة الانجاز</span>
                            <div class="wrap_input">
                                <input 
                                    min="0"
                                    max="100"
                                    type="number"
                                    placeholder="0"
                                    [value]="Progress"
                                    class="font_16 font_700"
                                    formControlName="achievementRatio" 
                                />
                                <span class="font_14 font_700 color_main_color">%</span>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="!isUploadingFiles && Form.get('media').value != null">
                        <p class="color_main_color mt-2 font_700 text-center">تم رفع عدد {{Form.get('media').value.length}} ملفات</p>
                    </ng-container>                    
                    <ng-container *ngIf="isUploadingFiles">
                        <p class="color_main_color mt-2 font_700 text-center">جاري رفع الملفات...</p>
                    </ng-container>
                    <ng-container *ngIf="Form.get('media').errors?.notSupported && Form.get('media').touched">
                        <p class="color_wrong mt-2 font_700 text-center">{{Form.get('media').errors?.notSupported}}</p>
                    </ng-container>
                    <ng-container *ngIf="Form.errors?.controlError && Form.touched">
                        <p class="color_wrong mt-2 font_700 text-center">{{Form.errors?.controlError}}</p>
                    </ng-container>                    
                </form>
            </app-content-card>
        </div>
    </app-overlay-container>
</ng-container>

<div class="advertisement_progress_timeline">
    <div class="custom_container">
        <div class="row">

            <!-- start create post action -->
             <ng-container *ngIf="(UserInfo | async)?.appOwner">
                 <div class="col-12 margin_bottom_7">
                     <button 
                         (click)="ToggleCreatePostFormVisible()"
                         class="create_post_btn btn d-flex justify-content-center align-items-center gap-2 bg-white main_color border_r_full border_solid border_main_color padding_x_7 padding_y font_20 font_700"
                     >
                         <app-drawer-alt />
                         <span>اكتب منشور</span>
                     </button>
                 </div>
             </ng-container>
            <!-- end create post action -->

            <!-- start Progress -->
            <div class="col-12 margin_bottom_9">
                <div #ProgressContainer class="progress_container d-flex justify-content-center align-items-center text-center position-relative overflow-hidden border_radius_8">
                    <div class="progress_text font_20 font_700 color_main_color">
                        <ng-container *ngIf="Progress < 100; else CompletedTemp">
                            <ng-container *ngFor="let char of SplitText; trackBy: trackByChar">
                                <span #ProgressChar class="split_text d-inline">{{char}}</span>                            
                            </ng-container>
                        </ng-container>
                        <ng-template #CompletedTemp>
                            <span class="margin_end color_white">100%</span>
                            <i class="fa-solid fa-circle-check color_white"></i>
                        </ng-template>                        
                    </div>
                    <div #ProgressBar class="progress_bar bg_main_color" [style.width]="Progress + '%'" ></div>
                </div>
            </div>
            <!-- end Progress -->

            <!-- start loader -->
            <ng-container *ngIf="IsLoading && Posts.length === 0">
                <div class="col-12 wrap_app_loading position-relative">
                    <app-loader [preventScroll]="true" [sm]="true" size="fa-5x" />    
                </div>
            </ng-container>
            <!-- end loader -->

            <!-- start post -->
            <ng-container *ngIf="!IsLoading || Posts.length > 0">
                <ng-container *ngFor="let post of Posts; let last = last; trackBy: trackById">
                    <div class="col-12 post position-relative">

                        <!-- start loader delete -->
                        <ng-container *ngIf="CurrentPostsDeleting.includes(post.id)">
                            <app-loader [preventScroll]="true" [sm]="true" size="fa-5x" class="bottom-50" />
                        </ng-container>
                        <!-- end loader delete -->

                        <ng-container *ngIf="(UserInfo | async)?.appOwner">
                            <div class="post_header d-flex justify-content-between align-items-center">
                                <h3 class="text-decoration-underline font_20 font_700 mb-0">الوصف:</h3>
    
                                <!-- start action -->
                                <button
                                    #DeleteBtn
                                    (click)="DeletePost(post.id)"
                                    class="action d-flex justify-content-center align-items-center btn btn-danger float-end border_radius_2 border_solid border_wrong text-center pointer padding_full"
                                >
                                    <i class="fas fa-trash text-white"></i>
                                </button>
                                <!-- end action -->
                            </div>
    
                            <hr class="margin_top_2">
                        </ng-container>
    
                        <!-- start title -->
                        <h4 class="font_24 font_700 color_black margin_bottom_5 text-break" [innerHTML]="post?.content"></h4>
                        <!-- end title -->

                        <!-- start media -->
                         <ng-container *ngIf="post.media?.length > 0">
                             <div appNgxViewer [viewerOptions]="{transition: true}" class="row border_solid border_main_color border_radius_2">
                                 <ng-container *ngFor="let media of post.media; let last = last">
                                     <div class="wrap_media col-12 col-md-6 padding_full_2 flex-grow-1">
                                         <ng-container [ngSwitch]="media.mediaType">
                                             <ng-container class="wrap_img" *ngSwitchCase="CHAT_DATA_TYPE.img">
                                                 <img class="img-fluid pointer" [src]="media.original" loading="lazy" fetchpriority="high" />
                                             </ng-container>
                                             <ng-container class="wrap_video h-100" *ngSwitchCase="CHAT_DATA_TYPE.video">
                                                 <video class="h-100" [src]="media.original" [poster]="media.thumbnail" controls preload="none"></video>
                                             </ng-container>
                                             <ng-container *ngSwitchCase="CHAT_DATA_TYPE.pdf">
                                                 <a [href]="media.original" class="wrap_pdf d-flex justify-content-center align-items-center h-100" target="_blank" rel="noopener noreferrer">
                                                     <i class="fas fa-file-pdf"></i>
                                                 </a>
                                             </ng-container>
                                             <ng-container *ngSwitchDefault>
                                                 محتوي الملف غير معروف
                                             </ng-container>
                                         </ng-container>
                                     </div>
                                 </ng-container>
                             </div>
                         </ng-container>
                        <!-- end media -->
    
                        <ng-container *ngIf="!last || IsLoadMore">
                            <hr class="margin_top_8 margin_bottom_12">
                        </ng-container>
    
                    </div>
                </ng-container>
            </ng-container>
            <!-- end post -->

            <!-- start loadMore -->
            <ng-container *ngIf="IsLoadMore">
                <div class="col-12 text-center mt-5">
                    <ng-container *ngIf="!IsLoading; else loadingTemp">
                        <button (click)="NextPage()" [disabled]="IsLoading" class="btn bg_main_color color_white font_16 font_600">تحمل المزيد</button>
                    </ng-container>
                    <ng-template #loadingTemp>
                        <h6 class="color_main_color font_16 font_700 mb-0">جاري تحميل...</h6>
                    </ng-template>
                </div>
            </ng-container>
            <!-- end loadMore -->

        </div>
    </div>
</div>